<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="sliderValues"
                display-unit="s"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'layer-transition-speed';
const DEFAULT_INDEX = 2; // should match the default set in o-layered-container.vue

export default {
    name: 'control-layer-transition',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Transition Speed',
            sliderIndex: DEFAULT_INDEX,
            sliderValues: [
                '0.1',
                '0.2',
                '0.3',
                '0.4',
                '0.5',
                '0.6',
                '0.7',
                '0.8',
                '0.9',
                '1',
                '2',
                '3',
                '4',
                '5',
            ],
        };
    },

    methods: {
        onInput(index) {
            const value = this.sliderValues[index];

            this.sliderIndex = index;
            this.setData(value);
            this.onOptionChange(value);
        },

        setData(value) {
            this.selectedElements.forEach((elem) => {
                elem.setElementData(CUSTOM_ATTR_NAME, value);
            });
        },

        onSelectedElement() {
            const value = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
            const sliderIndex = this.sliderValues.indexOf(value);

            this.sliderIndex = sliderIndex >= 0 ? sliderIndex : DEFAULT_INDEX;
        },
    },
};
</script>
